__turbopack_context__.v({
  "container": "ExternalTicketsPanel-module-scss-module__zPKjGW__container",
  "content": "ExternalTicketsPanel-module-scss-module__zPKjGW__content",
  "ctaButtonWrapper": "ExternalTicketsPanel-module-scss-module__zPKjGW__ctaButtonWrapper",
  "date": "ExternalTicketsPanel-module-scss-module__zPKjGW__date",
  "headline": "ExternalTicketsPanel-module-scss-module__zPKjGW__headline",
  "twoRailsCtaButtonWrapper": "ExternalTicketsPanel-module-scss-module__zPKjGW__twoRailsCtaButtonWrapper",
});
